<template>
  <div v-if="order">

    <div class="container checkout--expired" v-if="cartExpired">
      <p>{{content.checkoutExpiredHeader ||  "Sorry, but due to inactivity and for your security, your cart has expired" }} </p>

      <a class="button button--primary" href="/"> Leave checkout </a>
    </div>

    <section class="checkout" v-if="!cartExpired">
      <div class="container">
        <div class="checkout--content">
          <DeliverySlotCard v-for="(deliverySlot, index) in options" :key="index" :deliverySlot="deliverySlot"
            v-model="selected" />

          <div class="row delivery--next">
            <Spinner name="circle" color="var(--color-links)" v-if="loading" />
            <button class="button button--primary" @click="selectDeliverySlot(selected.id)" v-if="!loading"
              :disabled="!selected">
              Next
            </button>
          </div>
        </div>

        <div class="info-container">
          <div class="parent-container">
            <order-summary :deliverySlot="selected" />

            <div v-html="summaryBoxContent" v-if="summaryBoxContent" class="info"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import GoogleCookie from '@scripts/googleCookie'

import { CREATED, COMPLETED } from '@vue/common/constants/order'
import { actionTypes } from '@vue/common/constants/store.types'
import { ProductTypes } from '@vue/common/constants/productTypes'
import { setGoogleInfo, setDeliverySlot } from '@vue/services/api/checkout.api'

import Spinner from 'vue-spinkit'
import OrderSummary from '@vue/views/checkout/common/order-summary'
import DeliverySlotCard from './components/DeliverySlotCard'
import { getDeliverySlots } from '@vue/services/api/checkout.api'

export default {
  name: 'Delivery',
  components: {
    Spinner,
    DeliverySlotCard,
    OrderSummary,
  },
  data() {
    return {
      loading: false,
      selected: null,
      options: []
    }
  },
  computed: {
    ...mapState({
      order: (state) => state.checkout.order,
      store: (state) => state.store.store,
      content: (state) => state.checkout.content,
      cartExpired: (state) => state.cart.cartExpired
    }),
    storeName() {
      return this.order.store.brandName == ''
        ? this.order.store.name
        : `${this.order.store.brandName} - ${this.order.store.name}`
    },
    summaryBoxContent() {
      if(!this.content) {
        return null;
      }

      if(this.order.product.id !== ProductTypes.CLICK_AND_COLLECT && this.order.product.id !== ProductTypes.SELL_BACK) {
        return null;
      }

      // TODO: Remove paypoint hacks, paypoint is a brand not a whitelabel concept.
      return this.order.store.brand === 'PP'
        ? this.content.deliveryoptionsforccpaypoint
        : this.content.deliveryoptionsforcc;
    }
  },
  watch: {
    order(newValue) {
      { { this.order.state } }
      if (!newValue) return
      if (this.order.state.value === COMPLETED) {
        window.location = '/'
      }
      if (
        this.order.state.value !== CREATED ||
        this.order.state.value === COMPLETED
      ) {
        window.location = window.checkoutWorkflow.error
      }
    }
  },
  methods: {
    ...mapMutations({
      updateStep: 'checkout/updateStep',
      expiredOrder: 'checkout/expiredOrder',
    }),
    ...mapActions({
      initSession: 'session/init',
      getOrder: 'checkout/getOrder'
    }),
    selectDeliverySlot(id) {
      this.loading = true;
      setDeliverySlot(id)
        .then(() => {
          window.location = window.checkoutWorkflow.next
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    await this.initSession();
    this.updateStep('delivery')
    await this.getOrder()

    getDeliverySlots()
      .then(({ data }) => {
        this.options = data;
      });

    setGoogleInfo(GoogleCookie.getCookieValues())
  },
}
</script>
